import 'babel-polyfill';

const cookies = require('cookie-getter');

const { host } = window.location;

const DefaultConfig = cookies('config') || {};
const partners = cookies('partners') || {};
const partnerConf = cookies('partner_conf') || {};
const exceptionDomains = cookies('domain_exceptions');

// freeze it if browser supported
if (Object.freeze) {
  Object.freeze(DefaultConfig);
  Object.freeze(partners);
  Object.freeze(partnerConf);
  Object.freeze(exceptionDomains);
}

const partnerCookies = {};
let extraFields = {};
for (const partner in partners) {
  if (partner in partners) {
    const element = partners[partner];
    if (Object.values(exceptionDomains).indexOf(host) < 0) {
      extraFields = {
        legacyFolder: `https://${element}/folder/edit`,
        legacyUrl: `https://${element}`,
        legacyContent: `https://${element}`,
        getStateUrl: `https://${element}/api/calendarJson`,
        saveStateUrl: `https://${element}/api/calendar/saveCalendarJson`,
        updateStateUrl: `https://${element}/api/calendar/updateJson`,
        clearThumbnailURL: `https://${element}/api/calendar/clearthumbnails`,
        calendarDateImagesURL: `https://${element}/api/calendar/dateImages/type`,
        backgroundApiURL: `https://${element}/api/calendarBackgroundImages`,
      };
    }
    const copyPartnerConf = Object.assign({}, partnerConf, extraFields);
    Object.assign(partnerCookies, { [element]: copyPartnerConf });
  }
}

// export it
const config = Object.assign({}, DefaultConfig, partnerCookies);
export default config;



// WEBPACK FOOTER //
// ./src/services/clientconfig.js